import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actionOpenLaborTicketModal,
  actionOpenSetupActionModal,
} from 'lib/actions';
import { getUseSetupActionModal } from 'lib/selectors/getUseSetupActionModal';

/**
 * Returns a callback that starts the submit-work flow for the current labor
 * ticket context.
 *
 * Submit work opens the standard submit modal unless setup parts are skipped
 * and the current ticket is a setup ticket or belongs to the Unattended
 * operator, in which case it opens the setup action modal in submit mode.
 */
const useStartSubmitWork = () => {
  const dispatch = useDispatch();

  const useSetupActionModal = useSelector(getUseSetupActionModal);

  return useCallback(() => {
    if (useSetupActionModal) {
      return dispatch(actionOpenSetupActionModal('submit'));
    }
    return dispatch(actionOpenLaborTicketModal('submit'));
  }, [dispatch, useSetupActionModal]);
};

export default useStartSubmitWork;
